export function getXYFromEvent(event: MouseEvent | TouchEvent) {
  if (event instanceof MouseEvent) {
    return {x: event.pageX, y: event.pageY}
  } else {
    return {x: event.touches[0].pageX, y: event.touches[0].pageY}
  }
}